<twc-topbar>
    <twc-topbar-app>
        <img class="twc-topbar-app-logo" src="{{appLogo}}" height="32px" alt="{{'APP.ALT_LOGO' | translate}}" />
    </twc-topbar-app>

    <twc-breadcrumb [items]="breadcrumbs" cwChangeTwcIconsSize cwTwcIconWidth="30px" cwTwcIconHeight="30px">
    </twc-breadcrumb>

    <twc-topbar-actions class="topbar-actions">
        <ng-container *ngFor="let item of topBarItems; index as index">
            <twc-menu-wrapper *ngIf="item.options">
                <button class="twc-button" *ngIf="item.isVisible"
                    [ngClass]="item.isPrimaryButton ? 'twc-button-primary' : 'twc-button-link twc-pl-2 twc-pr-0'"
                    twcTooltip="{{item.keyText | translate}}" placement="bottom" cwBarsTooltip [isTopbar]="true">
                    <span class="twc-button-label" *ngIf="item.haveText">{{ item.keyText | translate }}</span>
                    <twc-icon *ngIf="item.haveIcon" [shape]="item.icon" [size]="item.iconSize"
                        [ngClass]="{'margin-left' : item.space}"></twc-icon>
                    <twc-icon shape="drop-down" [size]="item.dropDown"></twc-icon>
                </button>

                <twc-menu [position]="'bottom'" class="twc-mt-3">
                    <ng-container *ngFor="let option of item.options">
                        <twc-menu-option *ngIf="!option.isDivider && option.isVisible" (click)="option.onClick?.()"
                            [ngClass]="{ 'font-bold': isCurrentLang(option.code)}">
                            {{option.keyText ?? '' | translate }}
                            <twc-icon class="twc-ml-5" *ngIf="isCurrentLang(option.code)" shape="check">
                            </twc-icon>
                        </twc-menu-option>
                        <div *ngIf="option.isDivider" class="menu-divider"></div>
                    </ng-container>
                </twc-menu>
            </twc-menu-wrapper>
            <a download [href]="item.downloadUrl" class="twc-button download-button"
                *ngIf="item.isVisible && item.downloadUrl"
                [ngClass]="item.isPrimaryButton ? 'twc-button-primary' : 'twc-button-link twc-pl-2 twc-pr-2'"
                twcTooltip="{{item.keyText | translate}}"
                [position]="index !== (topBarItems.length - 1) ? 'bottom': 'bottom-left'">
                <twc-icon *ngIf="item.haveIcon" [shape]="item.icon" [size]="item.iconSize"
                    [ngClass]="{'margin-left' : item.space}"></twc-icon>
                <twc-badge [outline]="true" size="s" type="info" *ngIf="item.badge">{{ item.badge|
                    translate}}</twc-badge>
            </a>
        </ng-container>
    </twc-topbar-actions>
</twc-topbar>